import React from 'react';
import LessonHome from '../LessonHome';

const Lesson14 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson14;